import React from 'react'
import Form from '@active/react-ui/Form'
import {
  node,
} from 'prop-types'

const isFireFox = () => navigator.userAgent?.indexOf('Firefox') > -1

function InjectedForm({
  children,
  ...rest
}) {
  return (
    <Form
      disableBrowserValidation={isFireFox()}
      {...rest}
    >
      { children }
    </Form>
  )
}

InjectedForm.propTypes = {
  children: node.isRequired,
}

export default InjectedForm
